/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const ExportArrow16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray}
            fillRule="evenodd"
            d="M6.5 1a.5.5 0 01.09.992L6.5 2h-4a.5.5 0 00-.492.41L2 2.5v11a.5.5 0 00.41.492L2.5 14h11a.5.5 0 00.492-.41L14 13.5v-4a.5.5 0 01.992-.09L15 9.5v4a1.5 1.5 0 01-1.356 1.493L13.5 15h-11a1.5 1.5 0 01-1.493-1.356L1 13.5v-11a1.5 1.5 0 011.356-1.493L2.5 1h4zm9-1a.5.5 0 01.492.41L16 .5v6a.5.5 0 01-.992.09L15 6.5V1.706L7.854 8.854a.5.5 0 01-.765-.638l.057-.07L14.292 1H9.5a.5.5 0 01-.492-.41L9 .5a.5.5 0 01.41-.492L9.5 0h6z"
        />
    </AccessibleSVG>
);

export default ExportArrow16;
